import { render, staticRenderFns } from "./ClaimCustomer.vue?vue&type=template&id=0539e328"
import script from "./ClaimCustomer.vue?vue&type=script&lang=js"
export * from "./ClaimCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports